import { Phone, Mail, WEB_URL } from "../../../lib/constants/globalConstant";
const cookiePolicyData = {
  updatedOn: "1st November, 2024",
  title: "Cookie Policy",
  description: ` This Cookie Policy explains how
          <a href=${WEB_URL} target="_blank" class="text-primaryHeading">${WEB_URL}</a>
          ("we," "our," or "us") uses cookies and similar technologies to
          collect and process information as part of providing our services,
          including token purchases, rewards, and account-related alerts. By
          using our website, you agree to the use of cookies as described in
          this policy.`,
  sections: [
    {
      title: "1. What Are Cookies?",
      content:
        "Cookies are small text files stored on your device (computer, tablet, or mobile) when you visit a website. They enable the website to function effectively and provide a more personalized user experience by remembering preferences and actions.",
    },
    {
      title: "2. How We Use Cookies",
      content: "We use cookies to support and improve your experience while using our services, including:",
      list: [
        `<strong>Facilitating Token Purchases and Rewards Management:</strong> Cookies help maintain your session and save preferences related to purchasing tokens and managing rewards.`,
        `<strong>Enhancing User Experience:</strong> Cookies store information about your preferences, such as language settings, and help us provide personalized content.`,
        `<strong>Sending Account Alerts and Updates:</strong> Cookies may be used to remember your preferences for receiving email or text alerts, ensuring seamless communication.`,
        `<strong>Analyzing Website Performance:</strong> Cookies collect anonymous data on website traffic and user behavior to improve our services and enhance usability.`,
      ],
    },
    {
      title: "3. Types of Cookies We Use",
      content: "We use the following types of cookies:",
      list: [
        `<strong>Essential Cookies:</strong> These cookies are necessary for the operation of our website, such as enabling secure login, facilitating transactions, and maintaining session integrity.`,
        `<strong>Functional Cookies:</strong> These cookies remember your preferences, such as contact preferences for account alerts, and improve your personalized experience on our website.`,
        `<strong>Analytics Cookies:</strong> These cookies help us analyze user behavior on our website to optimize our services, including token purchases and rewards management.`,
        `<strong>Marketing Cookies:</strong> These cookies may be used to display relevant promotions or updates related to our services.`,
      ],
    },
    {
      title: "4. Third-Party Cookies",
      content:
        "We may use trusted third-party service providers for:",
      list: [
        "Payment processing.",
        "Email and text communication services.",
        "Data analysis to improve user experiences."
      ],
      subContent: "These third parties may place cookies on your device to facilitate their services. All third-party providers are required to adhere to confidentiality agreements and use your data only for the purposes outlined in our Privacy Policy."
    },
    {
      title: "5. Managing Cookies",
      content:
        "You have control over your cookie preferences. You can:",
      list: [
        "Adjust your browser settings to block or delete cookies.",
        "Opt out of certain analytics or marketing cookies through your account settings or browser tools."
      ],
      subContent: "Please note that disabling cookies may impact some functionalities of our website, such as completing purchases or receiving account alerts."
    },
    {
      title: "6. Data Collected Through Cookies",
      content:
        "The data collected through cookies may include:",
      list: [
        "Information about your browsing activity on our website.",
        "Preferences related to purchases, rewards, and alerts.",
        "General technical information, such as browser type and operating system.",
        "This information is processed in accordance with our Privacy Policy.",
      ]
    },
    {
      title: "7. Updates to This Cookie Policy",
      content:
        "We may update this Cookie Policy periodically to reflect changes in how we use cookies or comply with new legal requirements. Updates will be posted on this page with a new effective date.",
    },
    {
      title: "8. Contact Us",
      content:
        `If you have questions or concerns about this Cookie Policy, you can contact us:`,
      list: [
        `By emailing us at <a href="mailto:${Mail}" target="_blank" class="text-primaryHeading">${Mail}</a>`,
        `By calling us at <a href="tel:+${Phone}" target="_blank" class="text-primaryHeading">${Phone}</a>`,
      ],
    },
  ],
};

export default cookiePolicyData;
